class QuantityLimiter {
  constructor() {
    this.DEFAULT_MAX_QUANTITY = 5;
    this.STOPPEN_MET_ROKEN_MAX = 10;
    this.METAFIELD_NAMESPACE = 'custom';
    this.METAFIELD_KEY = 'maximaal_5_stuks_bestellen';
    this.cart = null;
    
    // Get the max quantity from the product info element (set by Liquid)
    const productInfo = document.querySelector('product-info');
    this.MAX_QUANTITY = parseInt(productInfo?.dataset.maxQuantity) || this.DEFAULT_MAX_QUANTITY;
    
    this.init();
  }

  async init() {
    await this.fetchCart();
    this.initProductPage();
    this.initCartPages();
    this.listenToCartUpdates();
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
    } catch (error) {
      console.error('Failed to fetch cart:', error);
    }
  }

  getCartQuantityForProduct(productId) {
    if (!this.cart || !this.cart.items) return 0;
    
    return this.cart.items
      .filter(item => item.product_id === productId)
      .reduce((total, item) => total + item.quantity, 0);
  }

  initProductPage() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const productId = productInfo.dataset.productId;
    const isLimited = productInfo.dataset.quantityLimited === 'true';
    
    if (!isLimited) return;

    const cartQty = this.getCartQuantityForProduct(parseInt(productId));
    const remaining = Math.max(0, this.MAX_QUANTITY - cartQty);

    console.log('Init product page:', { productId, cartQty, remaining, max: this.MAX_QUANTITY });

    this.updateProductPageUI(remaining, cartQty);
    this.interceptAddToCart(productId, remaining);
  }

  updateProductPageUI(remaining, cartQty) {
    const quantityInputs = document.querySelectorAll('quantity-input input[name="quantity"]');
    const addButtons = document.querySelectorAll('button[name="add"]');
    const productFormButtons = document.querySelectorAll('.product-form__buttons');
    const productForms = document.querySelectorAll('.product-form');

    console.log('Updating product page UI:', { remaining, cartQty });

    if (remaining <= 0) {
      // At maximum - hide quantity selector and disable button
      quantityInputs.forEach(input => {
        const quantityWrapper = input.closest('.product-form__quantity, quantity-input');
        if (quantityWrapper) {
          quantityWrapper.style.display = 'none';
        }
      });

      addButtons.forEach(btn => {
        btn.disabled = true;
        const btnText = btn.querySelector('.btn__text');
        if (btnText) btnText.textContent = 'Maximum bereikt';
      });

      // Hide ALL error elements in product forms
      productForms.forEach(form => {
        const errorWrappers = form.querySelectorAll('.product-form__error-message-wrapper');
        errorWrappers.forEach(wrapper => {
          wrapper.hidden = true;
          wrapper.style.display = 'none !important';
          wrapper.setAttribute('hidden', '');
          wrapper.style.visibility = 'hidden';
        });
        
        const errorMessages = form.querySelectorAll('.product-form__error-message');
        errorMessages.forEach(error => {
          error.hidden = true;
          error.style.display = 'none !important';
          error.setAttribute('hidden', '');
          error.style.visibility = 'hidden';
          error.textContent = '';
        });
      });

      productFormButtons.forEach(container => {
        // Skip if this is in the sticky bar
        const isInStickyBar = container.closest('.mobile-sticky-bar') || 
                             container.closest('[id*="sticky"]') ||
                             container.closest('.sticky-atc-bar');
        
        if (isInStickyBar) return;
        
        // Remove any existing message first
        let existingMessage = container.parentNode?.querySelector('.quantity-limit-message');
        if (existingMessage) existingMessage.remove();
        
        const message = document.createElement('div');
        message.className = 'quantity-limit-message text-sm';
        message.style.width = '100%';
        message.style.marginBottom = '8px';
        message.style.padding = '8px 12px';
        message.style.backgroundColor = '#fef3c7';
        message.style.border = '1px solid #fbbf24';
        message.style.borderRadius = '4px';
        message.style.display = 'block';
        message.style.clear = 'both';
        message.innerHTML = `Je hebt al het maximale aantal (${this.MAX_QUANTITY}) in je winkelwagen`;
        
        // Insert before the container to ensure it's on its own line
        container.parentNode.insertBefore(message, container);
      });
    } else {
      // Below maximum - show quantity selector and enable button
      quantityInputs.forEach(input => {
        input.max = remaining;
        input.setAttribute('data-max', remaining);
        input.setAttribute('max', remaining);
        
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > remaining) {
          input.value = remaining;
        }
        
        const quantityWrapper = input.closest('.product-form__quantity, quantity-input');
        if (quantityWrapper) {
          quantityWrapper.style.display = '';
        }

        // Update plus button state
        const quantitySelector = input.closest('quantity-input');
        if (quantitySelector) {
          const plusButton = quantitySelector.querySelector('button[name="plus"]');
          if (plusButton) {
            const value = parseInt(input.value) || 1;
            if (value >= remaining) {
              plusButton.disabled = true;
              plusButton.setAttribute('disabled', '');
              plusButton.style.opacity = '0.5';
              plusButton.style.cursor = 'not-allowed';
            } else {
              plusButton.disabled = false;
              plusButton.removeAttribute('disabled');
              plusButton.style.opacity = '';
              plusButton.style.cursor = '';
            }
          }
        }
      });

      // Enable add to cart buttons and reset text
      addButtons.forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        const btnText = btn.querySelector('.btn__text');
        if (btnText && btnText.textContent === 'Maximum bereikt') {
          btnText.textContent = 'In winkelwagen';
        }
      });

      // Show product form error messages again (in case they were hidden)
      productForms.forEach(form => {
        const errorWrappers = form.querySelectorAll('.product-form__error-message-wrapper');
        errorWrappers.forEach(wrapper => {
          wrapper.removeAttribute('hidden');
          wrapper.style.display = '';
          wrapper.style.visibility = '';
        });
        
        const errorMessages = form.querySelectorAll('.product-form__error-message');
        errorMessages.forEach(error => {
          error.removeAttribute('hidden');
          error.style.display = '';
          error.style.visibility = '';
        });
      });

      // Add event listeners to quantity inputs to update button state
      quantityInputs.forEach(input => {
        const updateButtonState = () => {
          const quantitySelector = input.closest('quantity-input');
          if (quantitySelector) {
            const plusButton = quantitySelector.querySelector('button[name="plus"]');
            if (plusButton) {
              const currentValue = parseInt(input.value) || 1;
              if (currentValue >= remaining) {
                plusButton.disabled = true;
                plusButton.setAttribute('disabled', '');
                plusButton.style.opacity = '0.5';
                plusButton.style.cursor = 'not-allowed';
              } else {
                plusButton.disabled = false;
                plusButton.removeAttribute('disabled');
                plusButton.style.opacity = '';
                plusButton.style.cursor = '';
              }
            }
          }
        };

        input.removeEventListener('input', updateButtonState);
        input.addEventListener('input', updateButtonState);
        input.removeEventListener('change', updateButtonState);
        input.addEventListener('change', updateButtonState);
      });

      productFormButtons.forEach(container => {
        // Skip if this is in the sticky bar
        const isInStickyBar = container.closest('.mobile-sticky-bar') || 
                             container.closest('[id*="sticky"]') ||
                             container.closest('.sticky-atc-bar');
        
        // Remove existing message (check both inside and before container)
        let existingMessage = container.querySelector('.quantity-limit-message');
        if (existingMessage) existingMessage.remove();
        
        existingMessage = container.parentNode?.querySelector('.quantity-limit-message');
        if (existingMessage) existingMessage.remove();

        if (isInStickyBar) return;

        const message = document.createElement('div');
        message.className = 'quantity-limit-message text-sm';
        message.style.width = '100%';
        message.style.marginBottom = '8px';
        message.style.display = 'block';
        message.style.clear = 'both';
        message.innerHTML = `Je kunt nog <strong>${remaining}</strong> toevoegen (max ${this.MAX_QUANTITY} per klant)`;
        
        // Insert before the container to ensure it's on its own line
        container.parentNode.insertBefore(message, container);
      });
    }
  }

  interceptAddToCart(productId, remaining) {
    const forms = document.querySelectorAll('form[is="product-form"]');
    
    forms.forEach(form => {
      // Remove existing listener first
      const existingHandler = form._quantityLimitHandler;
      if (existingHandler) {
        form.removeEventListener('submit', existingHandler, true);
      }
      
      const handler = async (e) => {
        // Always block submit immediately if limit reached
        const quantityInput = form.querySelector('input[name="quantity"]');
        const requestedQty = parseInt(quantityInput?.value || 1);
        
        // Synchronous check first with last known state
        // This prevents the form from submitting while we fetch fresh data
        const currentCartQty = this.getCartQuantityForProduct(parseInt(productId));
        
        if (currentCartQty >= this.MAX_QUANTITY) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          console.log('Blocked sync: Already at maximum');
          
          // Ensure button is disabled and message is shown
          this.updateProductPageUI(0, currentCartQty);
          return false;
        }

        if (currentCartQty + requestedQty > this.MAX_QUANTITY) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          console.log('Blocked sync: Requested quantity exceeds remaining');
          
          const remaining = this.MAX_QUANTITY - currentCartQty;
          this.updateProductPageUI(remaining, currentCartQty);
          return false;
        }
        
        // If sync check passes, do async check
        // We need to pause the form submission
        e.preventDefault();
        e.stopImmediatePropagation();
        
        try {
          await this.fetchCart();
          const freshCartQty = this.getCartQuantityForProduct(parseInt(productId));
          const freshRemaining = this.MAX_QUANTITY - freshCartQty;

          if (freshCartQty >= this.MAX_QUANTITY || requestedQty > freshRemaining) {
            console.log('Blocked async: Limit reached after fresh fetch');
            this.updateProductPageUI(freshRemaining, freshCartQty);
            return false;
          }
          
          // If check passes, we need to manually submit the form or trigger the theme's handler
          // But since we stopped propagation, we need to call the original submit
          // The safest way is to let the theme handle it by re-dispatching a new event
          // that we don't intercept, OR better: modify the theme's ProductForm
          
          // Let's try to bypass our own check by removing the listener temporarily
          form.removeEventListener('submit', handler, true);
          form.requestSubmit();
          // Re-add listener after submit
          setTimeout(() => {
            form.addEventListener('submit', handler, true);
          }, 100);
          
        } catch (err) {
          console.error('Error in async check:', err);
        }
      };
      
      form._quantityLimitHandler = handler;
      form.addEventListener('submit', handler, true);
    });
  }

  showError(form, message) {
    // Don't show error messages for quantity limited products
    // The yellow message is already shown in updateProductPageUI
    console.log('Error suppressed for quantity limited product:', message);
    return;
  }

  initCartPages() {
    const cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(item => {
      const variantId = item.dataset.variantId;
      const productId = this.getProductIdFromCartItem(item);
      const isLimited = item.dataset.quantityLimited === 'true';
      
      if (!isLimited) return;

      // Get max quantity from data attribute (10 for stoppen met roken, 5 for others)
      const maxQty = parseInt(item.dataset.maxQuantity) || this.DEFAULT_MAX_QUANTITY;
      const cartQty = this.getCartQuantityForProduct(productId);
      this.updateCartItemUI(item, cartQty, maxQty);
    });
  }

  getProductIdFromCartItem(item) {
    return parseInt(item.dataset.productId) || null;
  }

  updateCartItemUI(item, currentQty, maxQty = this.DEFAULT_MAX_QUANTITY) {
    const quantityInput = item.querySelector('quantity-input');
    if (!quantityInput) return;

    const input = quantityInput.querySelector('input');
    const plusButton = quantityInput.querySelector('button[name="plus"]');
    const minusButton = quantityInput.querySelector('button[name="minus"]');

    if (input) {
      input.max = maxQty;
      input.setAttribute('data-max', maxQty);
    }

    if (currentQty >= maxQty && plusButton) {
      plusButton.disabled = true;
      plusButton.style.opacity = '0.5';
      plusButton.style.cursor = 'not-allowed';
    }
  }

  listenToCartUpdates() {
    // Listen for cart updates
    document.addEventListener('cart:updated', async (event) => {
      console.log('Cart updated event detected');
      await this.fetchCart();
      
      if (window.location.pathname.includes('/products/')) {
        this.initProductPage();
      } else {
        this.initCartPages();
      }
    });

    // Listen for variant changes
    document.addEventListener('variant:changed', async () => {
      await this.fetchCart();
      if (window.location.pathname.includes('/products/')) {
        setTimeout(() => this.initProductPage(), 100);
      }
    });

    // Listen for cart drawer closing - important for updating product page
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const drawerObserver = new MutationObserver(async (mutations) => {
        for (const mutation of mutations) {
          if (mutation.attributeName === 'hidden') {
            const isHidden = cartDrawer.hasAttribute('hidden');
            
            if (isHidden && window.location.pathname.includes('/products/')) {
              // Cart drawer just closed, refresh product page limits
              console.log('Cart drawer closed, refreshing product page limits');
              await this.fetchCart();
              setTimeout(() => this.initProductPage(), 100);
            } else if (!isHidden) {
              // Cart drawer opened, refresh cart items
              setTimeout(() => this.initCartPages(), 200);
            }
          }
        }
      });
      
      drawerObserver.observe(cartDrawer, { 
        attributes: true, 
        attributeFilter: ['hidden', 'open'] 
      });
    }

    // Observe cart content changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.classList?.contains('cart-item') || node.querySelector?.('.cart-item')) {
                setTimeout(() => this.initCartPages(), 100);
              }
            }
          });
        }
      });
    });

    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
    
    const mainCart = document.querySelector('main-cart');
    if (mainCart) {
      observer.observe(mainCart, { childList: true, subtree: true });
    }

    // Also listen for FoxTheme pubsub events if available
    if (window.FoxTheme?.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS?.cartUpdate,
        async () => {
          console.log('FoxTheme cart update detected');
          await this.fetchCart();
          if (window.location.pathname.includes('/products/')) {
            this.initProductPage();
          }
        }
      );
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuantityLimiter();
  });
} else {
  new QuantityLimiter();
}

